import { outbrain, taboola } from 'js/analytics/adapters'
const trackedScrollDepths = new Set<string>()

export const trackScrollDepth = (scrollDepth: number) => {
  const key50Percent = `${window.location.pathname}-${50}-percent`
  if (scrollDepth > 50 && !trackedScrollDepths.has(key50Percent)) {
    trackedScrollDepths.add(key50Percent)
    taboola.track('view_content')
    outbrain.track('Content view')
  }
}
